<picture>
  <source media="(max-width: 600)" [srcset]="mobileUrl" />
  <source media="(min-width: 601px)" [srcset]="highResolutionUrl" />
  <img loading="lazy" class="hero-image" [src]="lowResolutionUrl" />
</picture>
